<template>
  <div class="cloudSmsList">
    <BasePage class="box-card">
      <div class="search-tool">
        <div class="search-item">
          <label class="item-label">时间：</label>
          <el-date-picker
            v-model="request.createTime"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
            @change="loadData"
          />
        </div>
        <div class="search-item">
          <label class="item-label">状态：</label>
          <el-select
            v-model="request.status"
            @change="loadData"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in cloudSmsStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="danger" size="small" icon="el-icon-plus" @click="add"
          >新增</el-button
        >
        <el-button
          type="info"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="!selectIdList || selectIdList.length === 0"
          @click="batchDelete"
          >删除</el-button
        >
      </div>

      <el-table
        :data="list"
        v-loading="isloading"
        border
        style="width: 100%; margin: 10px 0"
        :max-height="tableMaxHeight()"
        @selection-change="handleChange"
      >
        <el-table-column type="selection" width="40" :selectable="chkstu" />
        <el-table-column prop="Content" label="短信内容" />
        <el-table-column prop="Count" label="人数" width="80" align="center"/>
        <el-table-column prop="SendTime" label="发送时间" width="140" align="center">
          <template slot-scope="scope" width="120">
            {{ (scope.row.SendTime * 1000) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" width="140" align="center">
          <template slot-scope="scope" width="120">
            {{ (scope.row.CreateTime * 1000) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="状态" width="80" align="center">
          <template slot-scope="scope" width="120">
            {{ showStatus(scope.row.Status) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="innerSend(scope.row)"
              v-if="scope.row.Status === 1"
              >发送
            </el-button>
            <el-button
              type="text"
              size="mini"
              @click="innerEdit(scope.row)"
              v-if="scope.row.Status === 1"
              >编辑
            </el-button>
            <el-button type="text" size="mini" @click="queryDetail(scope.row)"
              >详情
            </el-button>
            <el-button
              type="text"
              size="mini"
              @click="deleteSms(scope.row)"
              v-if="scope.row.Status === 1"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wapper">
        <OfPagination
          :total="total"
          :pageSize="request.pageSize"
          :currentPage="request.pageIndex"
          @onSizeChange="handleSmsSizeChange"
          @onCurrentChange="handleSmsCurrentChange"
        />
      </div>
    </BasePage>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="900px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="短信内容：" prop="Content">
          <el-input
            v-model="form.Content"
            type="textarea"
            :rows="3"
            show-word-limit
            maxlength="300"
          />
        </el-form-item>
        <el-form-item label="人群：">
          <div>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-user-solid"
              @click="addMobile"
              >选择人群</el-button
            >
            <el-button
              type="danger"
              size="small"
              icon="el-icon-user-solid"
              @click="manuallyAdd"
              style="float: right; margin: 4px 0"
              >手动添加号码</el-button
            >
          </div>
          <el-table
            :data="form.CloudSmsDetailList"
            border
            style="width: 100%; margin-top: 15px"
            :max-height="detailTableMaxHeight()"
          >
            <el-table-column type="index" width="40" />
            <el-table-column
              prop="Name"
              label="名称"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              prop="Mobile"
              label="电话"
              width="120"
              align="center"
            />
            <el-table-column label="用户群体" width="150" align="center">
              <template slot-scope="scope">
                {{ showAccountType(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="Content"
              label="操作"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  @click="innerDelete(scope.row, scope.$index)"
                  type="text"
                  size="mini"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="btnLoading"
          >确 定</el-button
        >
      </span>
      <el-dialog
        title="选择接收人群"
        :visible.sync="showSelect"
        :append-to-body="true"
        :before-close="closeSelectDialog"
        :close-on-click-modal="false"
        width="1200px"
      >
        <div class="userGroups">
          <div class="userGroups-tool">
            <label class="item-label">选择接收人群：</label>
            <el-select
              clearable
              v-model="userGroupsRequest.accountType"
              placeholder="请选择"
              @change="getUserGroupsList(1)"
            >
              <el-option
                v-for="item in userGroupsType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <label
              class="item-label"
              style="margin-left: 10px"
              v-if="userGroupsRequest.accountType === 3"
              >在校学生：</label
            >
            <el-select
              v-model="userGroupsRequest.isSchool"
              v-if="userGroupsRequest.accountType === 3"
              placeholder="请选择"
              @change="getUserGroupsList(1)"
              clearable
            >
              <el-option
                v-for="item in isSchoolArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input placeholder="请输入关键字" style="width:200px;margin-left:10px" icon="el-icon-search" size="small" v-model="userGroupsRequest.searchKey" @input="search"></el-input>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-user-solid"
              style="float: right; margin-right: 5px"
              @click="addAllSelected"
              :disabled="!selectedList || selectedList.length === 0"
              >添加</el-button
            >
          </div>
          <el-row>
            <el-col :span="14">
              <el-table
                ref="multiple"
                :data="userGroupsList"
                border
                style="width: 100%; margin-top: 15px"
                class="userGroupsTable"
                :height="tableMaxHeight()"
                v-loading="userGroupsLoading"
                @selection-change="handleSelectionChange"
                @select="handleSelect"
                @select-all="selectAll"
              >
                <el-table-column type="selection" width="55" />
                <el-table-column
                  prop="Name"
                  label="名称"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  prop="Mobile"
                  label="电话"
                  width="125"
                  align="center"
                />
                <el-table-column label="操作" width="80" align="center">
                  <template slot-scope="scope">
                    <el-button
                      @click="innerAdd(scope.row)"
                      type="text"
                      size="mini"
                      >添加</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <OfPagination
                :total="userGroupsTotal"
                :pageSize="userGroupsRequest.pageSize"
                :currentPage="userGroupsRequest.pageIndex"
                :pagerCount="5"
                @onSizeChange="handleSizeChange"
                @onCurrentChange="handleCurrentChange"
              />
            </el-col>
            <el-col :span="10">
              <el-card
                class="selectUserGroup"
                shadow="never"
                :body-style="{
                  height: tableMaxHeight() - 54 + 'px',
                  overflow: 'auto',
                }"
              >
                <div slot="header">已选择人员</div>
                <el-tag
                  v-for="(tag, index) in selectedList"
                  :key="index"
                  closable
                  type="warning"
                  class="tag-item"
                  @close="closeTag(index)"
                >
                  {{ tag.Name }}
                </el-tag>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <el-dialog
        title="添加号码"
        :visible.sync="showManual"
        :append-to-body="true"
        :before-close="closeManualDialog"
        :close-on-click-modal="false"
        width="900px"
      >
        <!-- <el-form
          ref="manualForm"
          :model="manualForm"
          :rules="manualRules"
          label-width="100px"
        >
          <el-form-item label="姓名：" prop="Name">
            <el-input v-model="manualForm.Name" maxlength="50" />
          </el-form-item>
          <el-form-item label="手机号码：" prop="Mobile">
            <el-input v-model="manualForm.Mobile" maxlength="11" />
          </el-form-item>
        </el-form> -->
        <div class="addGroup">
          <div class="box-item">
            <label>姓名：</label>
            <el-input
              class="value-input"
              v-model="manualForm.Name"
              maxlength="50"
              clearable
            />
          </div>
          <div class="box-item">
            <label>手机号码：</label>
            <el-input
              class="value-input"
              v-model="manualForm.Mobile"
              maxlength="11"
              clearable
            />
          </div>
          <div class="box-item">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-plus"
              @click="addUser"
              >添 加</el-button
            >
          </div>
        </div>
        <el-table :data="manualList" border style="width: 100%">
          <el-table-column type="index" width="50" />
          <el-table-column prop="Name" label="姓名" />
          <el-table-column prop="Mobile" label="手机号码" />
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="removeManual(scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showManual = false">取 消</el-button>
          <el-button type="primary" @click="addDetail">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <el-dialog
      title="查看详情"
      :visible.sync="showQuery"
      :before-close="closeQueryDialog"
      :close-on-click-modal="false"
      width="60%"
    >
      <div class="query-box">
        <div class="box-item">
          <div class="item-label">短信内容：</div>
          <div class="item-value">
            <el-input
              v-model="form.Content"
              type="textarea"
              :rows="3"
              show-word-limit
              maxlength="300"
              readonly
            />
          </div>
        </div>
        <div class="box-item">
          <div class="item-label">人群：</div>
          <div class="item-value">
            <el-table
              :data="form.CloudSmsDetailList"
              border
              style="width: 100%; margin-top: 15px"
              :max-height="queryTableMaxHeight()"
            >
              <el-table-column type="index" width="40" />
              <el-table-column
                prop="Name"
                label="名称"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="Mobile"
                label="电话"
                width="120"
                align="center"
              />
              <el-table-column label="用户群体" width="150" align="center">
                <template slot-scope="scope">
                  {{ showAccountType(scope.row) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page";
import { formatData } from "@/utils";
import api from "@/modules/zjrc/api";
import OfPagination from "@/components/controls/of_pagination/of_pagination";

export default {
  name: "CloudSmsList",
  data() {
    return {
      request: {
        pageIndex: 1,
        pageSize: 15,
        createTime: "",
        status: "",
      },
      list: [],
      total: 0,
      isloading: false,
      dialogVisible: false,
      title: "",
      btnLoading: false,
      form: {
        Id: "",
        Content: "",
        Count: 0,
        Status: 0,
        CreateTime: "",
        SendTime: "",
        CloudSmsDetailList: [],
      },
      showSelect: false,
      userGroupsList: [],
      userGroupsTotal: 0,
      userGroupsRequest: {
        pageIndex: 1,
        pageSize: 15,
        accountType: 3,
        isSchool: "",
        searchKey: ''
      },
      userGroupsLoading: false,
      selectedList: [],
      showManual: false,
      manualForm: {
        Id: "",
        CloudSmsId: "",
        Name: "",
        Mobile: "",
        AccountType: "",
        Status: "",
        SendTime: "",
      },
      manualRules: {
        Name: {
          required: true,
          message: "姓名不能为空",
          trigger: "blur",
        },
        Mobile: [
          {
            required: true,
            message: "手机号码不能为空",
            trigger: "blur",
          },
          {
            pattern: /^(?:(?:\+|00)86)?1\d{10}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
      },
      rules: {
        Content: {
          required: true,
          message: "短信内容不能为空",
          trigger: "blur",
        },
      },
      selectIdList: [],
      showQuery: false,
      manualList: [],
      isSchoolArr: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ],
      carBodyHeight: "",
    };
  },
  components: {
    BasePage,
    OfPagination,
  },
  mounted() {
    const vm = this;
    vm.loadData();
  },
  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.getUserGroupsList(1)
      }, 500)
    },
    removeManual(index) {
      const vm = this;
      if (vm.manualList && vm.manualList.length > 0) {
        vm.manualList.splice(index, 1);
      }
    },
    addUser() {
      const vm = this;
      if (vm.manualForm.Name === "" || vm.manualForm.Mobile === "") {
        vm.$message.error("姓名或手机号码不能为空");
        return;
      }
      const str = /^[1]+[0-9]{10}$/;
      if (!str.test(vm.manualForm.Mobile)) {
        vm.$message.error("手机号码格式错误");
        return;
      }
      if (vm.form.CloudSmsDetailList && vm.form.CloudSmsDetailList.length > 0) {
        const checkObj = vm.form.CloudSmsDetailList.filter(
          (x) => x.Mobile === vm.manualForm.Mobile
        );
        if (checkObj && checkObj.length > 0) {
          this.$message({
            message: `号码：【${vm.manualForm.Mobile}】已存在，请勿重复添加`,
            type: "warning",
          });
          return;
        }
      }
      if (vm.manualList.length > 0) {
        const manualObj = vm.manualList.filter(
          (x) => x.Mobile === vm.manualForm.Mobile
        );
        if (manualObj && manualObj.length > 0) {
          this.$message({
            message: `号码：【${vm.manualForm.Mobile}】已存在，请勿重复添加`,
            type: "warning",
          });
          return;
        }
      }
      vm.manualList.push(Object.assign({}, vm.manualForm));
    },
    handleSmsSizeChange(val) {
      const vm = this;
      vm.request.pageIndex = 1;
      vm.request.pageSize = val;
      vm.loadData();
    },
    handleSmsCurrentChange(val) {
      const vm = this;
      if (this.total > vm.request.pageSize) {
        vm.request.pageIndex = val;
        vm.loadData();
      }
    },
    queryTableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 310;
      }
      return tableMaxHeight;
    },
    queryDetail(row) {
      const vm = this;
      const param = { cloudSmsId: row.Id };
      vm.form = Object.assign({}, row);
      api.getCloudSmsDetailList(param).then((res) => {
        if (res.data.Code === 0) {
          vm.form.CloudSmsDetailList = res.data.Data;
        }
      });
      vm.showQuery = true;
    },
    closeQueryDialog() {
      const vm = this;
      vm.showQuery = false;
    },
    batchDelete() {
      const vm = this;
      vm.$confirm(`确定批量删除选中短信`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.isloading = true;
        api.deleteCloudSms(vm.selectIdList).then((res) => {
          if (res.data.Code === 0) {
            vm.$message({
              message: "删除成功",
              type: "success",
            });
            vm.loadData();
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
          vm.isloading = false;
        });
      });
    },
    chkstu(row) {
      return row.Status === 1;
    },
    handleChange(arry) {
      const vm = this;
      if (arry.length === 0) {
        vm.selectIdList = [];
      } else {
        vm.selectIdList = arry.map((x) => x.Id);
      }
    },
    deleteSms(row) {
      const vm = this;
      vm.$confirm(`确定删除短信【${row.Content}】`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.isloading = true;
        const params = [row.Id];
        api.deleteCloudSms(params).then((res) => {
          if (res.data.Code === 0) {
            vm.$message({
              message: "删除成功",
              type: "success",
            });
            vm.loadData();
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
          vm.isloading = false;
        });
      });
    },
    innerSend(row) {
      const vm = this;
      vm.$confirm(`确定发送短信【${row.Content}】`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.isloading = true;
        const param = { id: row.Id };
        api
          .sendCloudSms(param)
          .then((res) => {
            if (res.data.Code === 0) {
              vm.$message({
                message: "提交成功",
                type: "success",
              });
              vm.loadData();
            } else {
              this.$message({
                message: res.data.Message,
                type: "error",
              });
            }
            vm.isloading = false;
          })
          .catch(() => {
            vm.isloading = false;
          });
      });
    },
    innerEdit(row) {
      const vm = this;
      vm.title = "编辑云端短信";
      vm.form = Object.assign({}, row);
      const param = { cloudSmsId: row.Id };
      api.getCloudSmsDetailList(param).then((res) => {
        if (res.data.Code === 0) {
          vm.form.CloudSmsDetailList = res.data.Data;
        }
      });
      vm.dialogVisible = true;
    },
    submit() {
      const vm = this;
      vm.$refs.form.validate((valid) => {
        if (valid) {
          vm.btnLoading = true;
          const param = Object.assign({}, vm.form);
          param.CreateTime = 0;
          param.SendTime = 0;
          api
            .saveCloudSms(param)
            .then((res) => {
              if (res.data.Code === 0) {
                vm.$message({
                  message: "提交成功",
                  type: "success",
                });
                vm.loadData();
                vm.dialogVisible = false;
              } else {
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
              vm.btnLoading = false;
            })
            .catch(() => {
              vm.btnLoading = false;
            });
        }
      });
    },
    addDetail() {
      const vm = this;
      // vm.$refs.manualForm.validate((valid) => {
      //   if (valid) {
      //     const checkObj = vm.form.CloudSmsDetailList.filter(
      //       (x) => x.Mobile === vm.manualForm.Mobile
      //     );
      //     if (checkObj && checkObj.length > 0) {
      //       this.$message({
      //         message: `号码：【${vm.manualForm.Mobile}】已存在，请勿重复添加`,
      //         type: "warning",
      //       });
      //       return;
      //     }
      //     const obj = {
      //       Id: "",
      //       CloudSmsId: "",
      //       Name: vm.manualForm.Name,
      //       Mobile: vm.manualForm.Mobile,
      //       AccountType: 5,
      //       Status: 0,
      //       SendTime: 0,
      //     };
      //     vm.form.CloudSmsDetailList.push(obj);
      //     vm.showManual = false;
      //   }
      // });
      if (!vm.manualList || vm.manualList.length === 0) {
        vm.$message.error("请添加号码");
        return;
      }
      vm.manualList.forEach((item) => {
        const obj = {
          Id: "",
          CloudSmsId: "",
          Name: item.Name,
          Mobile: item.Mobile,
          AccountType: 5,
          Status: 0,
          SendTime: 0,
        };
        vm.form.CloudSmsDetailList.push(obj);
      });

      vm.showManual = false;
    },
    manuallyAdd() {
      const vm = this;
      vm.manualForm = {
        Id: "",
        CloudSmsId: "",
        Name: "",
        Mobile: "",
        AccountType: "",
        Status: "",
        SendTime: "",
      };
      vm.showManual = true;
    },
    closeManualDialog() {
      const vm = this;
      vm.showManual = false;
    },
    detailTableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 450;
      }
      return tableMaxHeight;
    },
    addAllSelected() {
      const vm = this;
      const json = JSON.stringify(vm.selectedList);
      const jsonArray = JSON.parse(json);
      if (
        !vm.form.CloudSmsDetailList ||
        vm.form.CloudSmsDetailList.length === 0
      ) {
        vm.form.CloudSmsDetailList = jsonArray;
      } else {
        const mobiles = jsonArray.map((x) => x.Mobile);
        for (var i = 0; i < vm.form.CloudSmsDetailList.length; i++) {
          if (mobiles.includes(vm.form.CloudSmsDetailList[i].Mobile)) {
            this.$message({
              message: `号码：【${vm.form.CloudSmsDetailList[i].Mobile}】已存在，请勿重复添加`,
              type: "warning",
            });
            return;
          }
        }
        jsonArray.forEach((item) => {
          vm.form.CloudSmsDetailList.push(item);
        });
      }
      vm.showSelect = false;
      vm.selectedList = []
    },
    closeTag(index) {
      const vm = this;
      const i = vm.userGroupsList.findIndex(
        (x) =>
          x.Name === vm.selectedList[index].Name &&
          x.Mobile === vm.selectedList[index].Mobile
      );
      if (i !== -1) {
        vm.$nextTick(() => {
          vm.$refs.multiple.toggleRowSelection(
            vm.$refs.multiple.data[i],
            false
          );
        });
      }
      vm.selectedList.splice(index, 1);
    },
    selectAll(selection) {
      const vm = this;
      if (selection.length > 0) {
        const mobile = vm.selectedList.map((x) => x.Name);
        const name = vm.selectedList.map((x) => x.Name);
        const array = selection.filter(
          (x) => !mobile.includes(x.Name) && !name.includes(x.Name)
        );
        if (array.length > 0) {
          array.forEach((item) => {
            vm.selectedList.push(item);
          });
        }
      } else {
        if (vm.userGroupsList && vm.userGroupsList.length > 0) {
          vm.userGroupsList.forEach((item) => {
            const index = vm.selectedList.findIndex(
              (x) => x.Name === item.Name && x.Mobile === item.Mobile
            );
            if (index !== -1) {
              vm.selectedList.splice(index, 1);
            }
          });
        }
      }
    },
    handleSelect(selection, row) {
      const vm = this;
      const index = selection.findIndex(
        (x) => x.Name === row.Name && x.Mobile === row.Mobile
      );
      if (index !== -1) {
        const obj = vm.selectedList.filter(
          (x) => x.Name === row.Name && x.Mobile === row.Mobile
        );
        if (obj.length === 0) {
          vm.selectedList.push(row);
        }
      } else {
        const i = vm.selectedList.findIndex(
          (x) => x.Name === row.Name && x.Mobile === row.Mobile
        );
        if (i !== -1) {
          vm.selectedList.splice(i, 1);
        }
      }
    },
    handleSelectionChange(val) {
      const vm = this;
      // vm.selectedList = val;
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 300;
      }
      return tableMaxHeight;
    },
    handleSizeChange(val) {
      const vm = this;
      vm.userGroupsRequest.pageIndex = 1;
      vm.userGroupsRequest.pageSize = val;
      vm.getUserGroupsList();
    },
    handleCurrentChange(val) {
      const vm = this;
      if (this.userGroupsTotal > vm.userGroupsRequest.pageSize) {
        vm.userGroupsRequest.pageIndex = val;
        vm.getUserGroupsList();
      }
    },
    innerAdd(row) {
      const vm = this;
      if (
        !vm.form.CloudSmsDetailList ||
        vm.form.CloudSmsDetailList.length === 0
      ) {
        vm.form.CloudSmsDetailList = [];
        vm.form.CloudSmsDetailList.push(row);
      } else {
        const obj = vm.form.CloudSmsDetailList.filter(
          (x) => x.Mobile === row.Mobile
        );
        if (obj && obj.length > 0) {
          this.$message({
            message: `号码：【${row.Mobile}】已存在，请勿重复添加`,
            type: "warning",
          });
          return;
        }
        vm.form.CloudSmsDetailList.push(row);
      }
      vm.showSelect = false;
    },
    getUserGroupsList(pageIndex) {
      const vm = this;
      vm.userGroupsLoading = true;
      vm.userGroupsRequest.pageIndex = pageIndex
        ? pageIndex
        : vm.userGroupsRequest.pageIndex;
      api
        .getUserGroupsList(vm.userGroupsRequest)
        .then((res) => {
          if (res.data.Code === 0) {
            vm.userGroupsTotal = res.data.Data.total;
            vm.userGroupsList = res.data.Data.rows;
          }
          if (
            vm.selectedList &&
            vm.selectedList.length > 0 &&
            vm.userGroupsList &&
            vm.userGroupsList.length > 0
          ) {
            vm.selectedList.forEach((item) => {
              const index = vm.userGroupsList.findIndex(
                (x) => x.Name === item.Name && x.Mobile === item.Mobile
              );
              if (index !== -1) {
                vm.$nextTick(() => {
                  vm.$refs.multiple.toggleRowSelection(
                    vm.$refs.multiple.data[index],
                    true
                  );
                });
              }
            });
          }
        })
        .finally(() => {
          vm.userGroupsLoading = false;
        });
    },
    addMobile() {
      const vm = this;
      vm.userGroupsRequest.pageIndex = 1;
      vm.userGroupsRequest.accountType = 3;
      vm.getUserGroupsList();
      vm.carBodyHeight = vm.tableMaxHeight;
      vm.showSelect = true;
    },
    closeSelectDialog() {
      const vm = this;
      vm.showSelect = false;
      vm.selectedList = [];
    },
    innerDelete(row, index) {
      const vm = this;
      vm.form.CloudSmsDetailList.splice(index, 1);
    },
    add() {
      const vm = this;
      vm.form = {
        Id: "",
        Content: "",
        Count: 0,
        Status: 0,
        CreateTime: 0,
        SendTime: 0,
        CloudSmsDetailList: [],
      };
      vm.title = "新增云端短信";
      vm.dialogVisible = true;
    },
    handleClose() {
      const vm = this;
      vm.dialogVisible = false;
    },
    loadData() {
      const vm = this;
      vm.isloading = true;
      const param = Object.assign({}, vm.request);
      if (param.createTime) {
        param.createTime = param.createTime / 1000;
      }
      api.getCloudSmsList(param).then((res) => {
        if (res.data.Code === 0) {
          vm.total = res.data.Data.total;
          vm.list = res.data.Data.rows;
        }
        vm.isloading = false;
      });
    },
    showStatus(value) {
      return formatData(value, this.cloudSmsStatus);
    },
    showAccountType(row) {
      return formatData(row.AccountType, this.userGroupsType);
    },
  },
};
</script>
<style lang="scss" scoped>
.cloudSmsList {
  .box-card {
    padding: 10px;
  }

  .search-tool {
    display: flex;
    padding: 5px 0;

    .search-item {
      margin-right: 10px;

      .item-label {
        color: #606266;
        font-size: 14px;
      }

      /deep/ .el-input__prefix {
        display: none;
      }
    }
  }

  .search-btn {
    margin: 12px 0;
  }

  .userGroups {
    .userGroups-tool {
      .item-label {
        color: #606266;
        font-size: 14px;
      }
    }

    .userGroupsTable {
    }
  }

  .query-box {
    .box-item {
      display: flex;
      //   border-bottom: 1px dashed #c9c6c6;
      padding: 5px;

      .item-label {
        flex: 1;
        text-align: right;
        margin-right: 5px;
        color: #606266;
        font-size: 14px;
        line-height: 40px;
      }

      .item-value {
        flex: 7;
      }
    }
  }
}

.addGroup {
  display: flex;
  margin-bottom: 5px;

  .box-item {
    margin-right: 10px;
    padding: 10px 0;

    .value-input {
      width: 250px;
    }
  }
}

.selectUserGroup {
  margin: 15px 0px 15px 15px;

  /deep/ .el-card__header {
    padding: 16px 20px;
  }

  .tag-item {
    margin: 5px;
  }
}
</style>
